export interface HeroProps {
  onDeleteSession: () => void;
}

export function Hero({ onDeleteSession }: HeroProps) {
  return (
    <header className="hero">
      <div className="hero__bar">
        <p className="hero__brand mono">MCP App UI Kit</p>
        <button type="button" className="btn btn--ghost hero__delete" onClick={onDeleteSession}>
          Eliminar datos de esta sesión
        </button>
      </div>
      <div className="hero__content">
        <h1>Haz visible lo que normalmente falla en silencio.</h1>
        <p className="hero__lede">
          Catálogo de componentes React + TypeScript para el ciclo completo de una tool call
          MCP: permiso, confirmación, progreso, resultado y error. Prueba componentes con
          resultados, confirmaciones y fallos desde un catálogo de escenarios.
        </p>
        <p className="hero__privacy">
          Usa el ejemplo incluido o carga datos propios. El modo local no los envía a ningún
          servidor: todo corre en tu navegador.
        </p>
        <a href="#workbench" className="btn btn--primary hero__cta">
          Ejecutar escenario
        </a>
      </div>
    </header>
  );
}
